import axios from 'src/api/Api';
import {
    getUsageDetailsApiEndpoint,
    getDropdownEnpoint,
    getValidateMazorCodeEndpoint,
    procedureInfoEndpoint,
    validateProductDetailsEndpoint,
    validateReplenProductsEndpoint,
    usageAttachmentUploadEndpoint,
    createOrUpdateUsageEndpoint,
    deleteAttachmentEndpoint,
    getPricesForItemsEndpoint,
    getImagePoPreviewEndpoint,
    cancelUsageEndpoint,
    cancelUsageWithouReasonEndpoint,
    fetchDisparencyEndpoint,
    discrepancyAttachmentUploadEndpoint,
    checkIfOrderLockedEndpoint,
    orderUnlockEndpoint,
    discrepancyUpdateEndpoint,
    getOrderStatusDetailsApiEndpoint,
    getAccountMessageValidationApi,
    validateRelenEndPoint,
} from './endpoints';
import {
    accountNumberZeroTrimmer,
    convertObjectToQueryParams,
} from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { USAGE_CREATED_VIA_INTEGRATION_STATUS_CODE } from 'src/constants/appConstants';

// import axiosRetry from 'axios-retry';

// axiosRetry(axios, {
//     retries: 2,
//     shouldResetTimeout: true,
//     retryCondition: (_error) => true, // retry no matter what
// });

export const getUsageDetailsFunc = async (queryParams) => {
    try {
        const usageDetailsApiEndpoint = getUsageDetailsApiEndpoint(queryParams);
        const response = await axios.get(usageDetailsApiEndpoint);
        return response.data ? response.data : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: getUsageDetailsApiEndpoint(queryParams),
            requestPayload: queryParams
        });
        const errorData = error.response?.data;
        if (
            error.response?.status === 422 &&
            String(errorData?.statusCode) ===
                USAGE_CREATED_VIA_INTEGRATION_STATUS_CODE
        ) {
            return {
                status: 'failed',
                statusCode: errorData.statusCode,
                statusDescription: errorData.statusDescription,
            };
        }
        return 'error';
    }
};

export const createUsageOrderFunc = async (reportUsageObj) => {
    try {
        const response = await axios.post(
            createOrUpdateUsageEndpoint(),
            reportUsageObj
        );
        return response.data ? response.data : {};
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: createOrUpdateUsageEndpoint(),
            requestPayload: reportUsageObj
        });
        return e.response && e.response.data;
    }
};

export const updateUsageOrderFunc = async (reportUsageObj) => {
    try {
        const response = await axios.put(
            createOrUpdateUsageEndpoint(),
            reportUsageObj
        );
        return response.data ? response.data : {};
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: createOrUpdateUsageEndpoint(),
            requestPayload: reportUsageObj
        });
        return e.response && e.response.data;
    }
};

export const getPricesForItemsFunc = async (queryParams) => {
    try {
        const response = await axios.get(
            getPricesForItemsEndpoint(queryParams)
        );
        return response ? response.data : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: getPricesForItemsEndpoint(queryParams),
            requestPayload: queryParams
        });
        return 'error';
    }
};

export const getDropdownOptionsFunc = async (
    payload,
    accountPhysicianAPIReplenishment,
    accountPhysicianAPIUsage,
    physicianDropdownZGReportUsageReplenishmentVisibility,
    physicianDropdownZGReportUsageVisibility
) => {
    try {
        const { dropdownType, queryParams, salesOrg, countryISOCode } = payload;
        const dropdownEndpoint = getDropdownEnpoint(
            dropdownType,
            convertObjectToQueryParams({...queryParams, orderType : queryParams?.isReplenishmentPage ? 'ZLCR' : 'ZLB'}),
            accountPhysicianAPIReplenishment,
            accountPhysicianAPIUsage,
            physicianDropdownZGReportUsageReplenishmentVisibility,
            physicianDropdownZGReportUsageVisibility,
            salesOrg,
            countryISOCode
        );
        const response = await axios.get(dropdownEndpoint);

        if (dropdownType === 'accounts' || dropdownType === 'accountLookup') {
            const accountData = { ...response.data };
            let dropDownResult =
                accountData?.accounts && accountData.accounts?.length > 0
                    ? [...accountData.accounts]
                    : [];
            if (dropDownResult) {
                dropDownResult = dropDownResult.map((item) => {
                    const accountName = `${
                        item.accountName
                    } ${accountNumberZeroTrimmer(item.accountId)}`;
                    item.accountFormattedName = accountName;
                    item.filterValue = ` ${item.accountId} ${item.accountName} `;
                    return { ...item };
                });
            }
            accountData.accounts = dropDownResult;
            response.data = accountData;
        }
        if (dropdownType === 'billToDetails') {
            const billToDetailsData = { ...response.data };
            let dropDownResult =
                billToDetailsData?.billToDetails &&
                billToDetailsData.billToDetails?.length > 0
                    ? [...billToDetailsData.billToDetails]
                    : [];
            if (dropDownResult) {
                dropDownResult = dropDownResult.map((item) => {
                    const billToDetailsName = `${
                        item.billToName
                    } ${accountNumberZeroTrimmer(item.billToNumber)}`;
                    item.billToFormattedName = billToDetailsName;
                    item.filterValue = ` ${item.billToNumber} ${item.billToName} `;
                    return item;
                });
            }
            billToDetailsData.billToDetails = dropDownResult;
            response.data = billToDetailsData;
        }
        if (dropdownType === 'physicians') {
            const accountData = { ...response.data };
            let dropDownResult =
                accountData?.physicianList &&
                accountData.physicianList?.length > 0
                    ? [...accountData.physicianList]
                    : [];
            if (dropDownResult) {
                dropDownResult = dropDownResult.map((item) => {
                    const accountName = `${
                        item.physicianDisplayName
                    }  ${accountNumberZeroTrimmer(item.physicianId)}`;
                    item.physicianFormattedName = accountName;
                    item.filterValue = ` ${item.physcianId} ${item.physicianDisplayName} `;
                    return { ...item };
                });
            }
            accountData.physicians = dropDownResult;
            response.data = accountData;
        }
        return response ? response.data : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: getDropdownEnpoint(
                payload.dropdownType,
                convertObjectToQueryParams({...payload.queryParams, orderType : payload.queryParams?.isReplenishmentPage ? 'ZLCR' : 'ZLB'}),
                accountPhysicianAPIReplenishment,
                accountPhysicianAPIUsage,
                physicianDropdownZGReportUsageReplenishmentVisibility,
                physicianDropdownZGReportUsageVisibility,
                payload.salesOrg,
                payload.countryISOCode
            ),
            requestPayload: payload
        });
        return 'error';
    }
};

export const validateMazorCodeFunc = async (requestBody) => {
    try {
        const validateMazorCodeEndpoint = getValidateMazorCodeEndpoint(
            requestBody.mazorKitCode
        );
        const response = await axios.post(
            validateMazorCodeEndpoint,
            requestBody
        );
        return response && response.data;
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: getValidateMazorCodeEndpoint(requestBody.mazorKitCode),
            requestPayload: requestBody
        });
        return e.response && e.response.data;
    }
};

export const getProcedureInfoFunc = async (data) => {
    try {
        const response = await axios.get(
            procedureInfoEndpoint(convertObjectToQueryParams(data, true))
        );
        return response ? response.data : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: procedureInfoEndpoint(convertObjectToQueryParams(data, true)),
            requestPayload: data
        });
        return 'error';
    }
};

export const validateProductDetailsFunc = async (obj) => {
    try {
        const response = await axios.post(
            validateProductDetailsEndpoint(),
            obj
        );
        return response ? response.data : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: validateProductDetailsEndpoint(),
            requestPayload: obj
        });
        return 'error';
    }
};

export const validateRelenFunc = async (obj) => {
    try {
        const response = await axios.post(validateRelenEndPoint(), obj);
        return response ? response.data : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: validateRelenEndPoint(),
            requestPayload: obj
        });
        return 'error';
    }
};
export const validateUnidPlanFeeItemsFunc = async (obj) => {
    try {
        const response = await axios.post(
            validateProductDetailsEndpoint(),
            obj
        );
        return response ? response.data : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: validateProductDetailsEndpoint(),
            requestPayload: obj
        });
        return 'error';
    }
};

export const validateReplenProductsFunc = async (queryParams, salesOrg) => {
    try {
        const response = await axios.get(
            validateReplenProductsEndpoint(queryParams, salesOrg)
        );
        return response ? response.data : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: validateReplenProductsEndpoint(queryParams, salesOrg),
            requestPayload: { queryParams, salesOrg }
        });
        return 'error';
    }
};

export const usageAttachmentUploadFunc = async (obj) => {
    try {
        const response = await axios.post(usageAttachmentUploadEndpoint(), obj);

        return response ? response.data : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: usageAttachmentUploadEndpoint(),
            requestPayload: obj
        });
        return {};
    }
};

export const deleteAttachmentFunc = async (obj) => {
    try {
        const response = await axios.delete(
            deleteAttachmentEndpoint(obj.fileName),
            obj
        );
        return response ? response : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: deleteAttachmentEndpoint(obj.fileName),
            requestPayload: obj
        });
        return {};
    }
};
export const getImagePoPreviewFunc = async (obj) => {
    try {
        const response = await axios.get(
            getImagePoPreviewEndpoint(obj.fileName)
        );
        return response ? response : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: getImagePoPreviewEndpoint(obj.fileName),
            requestPayload: obj
        });
        return {};
    }
};

export const cancelUsageOrderFunc = async (cancelPayload) => {
    try {
        const response = await axios.put(
            cancelPayload.isCancelWithoutReason
                ? cancelUsageWithouReasonEndpoint(
                      cancelPayload.cancelUsageObj?.myCaseRef
                  )
                : cancelUsageEndpoint(),
            !cancelPayload.isCancelWithoutReason && cancelPayload.cancelUsageObj
        );
        return response.data ? response.data : {};
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: cancelPayload.isCancelWithoutReason
                ? cancelUsageWithouReasonEndpoint(cancelPayload.cancelUsageObj?.myCaseRef)
                : cancelUsageEndpoint(),
            requestPayload: cancelPayload
        });
        return e.response && e.response.data;
    }
};

export const getDisparencyFunc = async (queryParams) => {
    try {
        const disparencyApiEndpoint = fetchDisparencyEndpoint(queryParams);
        const response = await axios.get(disparencyApiEndpoint);
        return response.data ? response.data : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: fetchDisparencyEndpoint(queryParams),
            requestPayload: queryParams
        });
        return 'error';
    }
};
export const checkIfOrderLockedFunc = async (orderDetails) => {
    try {
        const response = await axios.get(
            checkIfOrderLockedEndpoint(orderDetails)
        );
        return response
            ? {
                  ...response.data,
                  myCaseRefId: orderDetails.myCaseRefId,
                  loader: false,
              }
            : false;
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: checkIfOrderLockedEndpoint(orderDetails),
            requestPayload: orderDetails
        });
        return 'error';
    }
};

export const discrepancyAttachmentUploadFunc = async (obj) => {
    try {
        const response = await axios.post(
            discrepancyAttachmentUploadEndpoint(),
            obj
        );
        return response ? response.data : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: discrepancyAttachmentUploadEndpoint(),
            requestPayload: obj
        });
        return {};
    }
};
export const discrepancyDeleteAttachmentFunc = async (obj) => {
    try {
        const response = await axios.delete(
            deleteAttachmentEndpoint(obj.fileName),
            obj
        );
        return response ? response : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: deleteAttachmentEndpoint(obj.fileName),
            requestPayload: obj
        });
        return {};
    }
};
export const unlockOrderFunc = async (orderDetails) => {
    try {
        const response = await axios.delete(orderUnlockEndpoint(orderDetails));
        return response ? response.data : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: orderUnlockEndpoint(orderDetails),
            requestPayload: orderDetails
        });
        return 'error';
    }
};

export const discrepancyUpdateDataFunc = async (obj) => {
    try {
        const response = await axios.post(discrepancyUpdateEndpoint(), obj);
        return response ? response.data : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: discrepancyUpdateEndpoint(),
            requestPayload: obj
        });
        return {};
    }
};

export const getOrderStatusDetailsFunc = async (queryParams) => {
    try {
        const orderStatusDetailsApiEndpoint =
            getOrderStatusDetailsApiEndpoint(queryParams);
        const response = await axios.get(orderStatusDetailsApiEndpoint);
        return response.data ? response.data : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: getOrderStatusDetailsApiEndpoint(queryParams),
            requestPayload: queryParams
        });
        return 'error';
    }
};

export const getAccountMessageValidationFunc = async (queryParams) => {
    const params = convertObjectToQueryParams(queryParams);
    const url = getAccountMessageValidationApi(params);
    try {
        const response = await axios.get(url);
        return response.data ? response.data : {};
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: queryParams
        });
        return 'error';
    }
};
